/**
 * Runtime-injected flag that gates the IO line-tracing features:
 * the Lines tab, the /v2/documents/:id/lines/* API calls, and the
 * user-drawn Equipment bounding-box type.
 *
 * Value flow:
 *   - `.env.production` maps VITE_IO_LINE_TRACING -> the placeholder
 *     string "INTAI_ENV_IO_LINE_TRACING".
 *   - Vite inlines that literal into the bundle at build time.
 *   - On pod start, docker-fix-env.sh sed-replaces the placeholder
 *     with the runtime value of INTAI_ENV_IO_LINE_TRACING.
 *
 * This mirrors how VITE_API_URL / VITE_KEYCLOAK_* are injected — one
 * image, per-pod env wins.
 */

const raw = (import.meta.env.VITE_IO_LINE_TRACING ?? '').toString().trim().toLowerCase()

export const IO_LINE_TRACING_ENABLED: boolean =
  raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on'
